import { Divider, Grid, Menu, MenuItem, Typography } from "@mui/material";
import { withStyles, WithStyles } from "@mui/styles";
import { FeedStyleClasses } from "assets/jss/common-styles";
import ButtonCardAction from "components/Buttons/ButtonCardAction";
import ButtonDashboard from "components/Buttons/ButtonDashboard";
import ButtonEllipsis from "components/Buttons/ButtonEllipsis";
import IconButtonEdit from "components/Buttons/IconButtonEdit";
import IconClipboardCheck from "components/Icons/IconClipboardCheck";
import IconUsersPlus from "components/Icons/IconUsersPlus";
import MuiClickable from "components/MuiExtras/MuiClickable";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiImage from "components/MuiExtras/MuiImage";
import MuiPaper from "components/MuiExtras/MuiPaper";
import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import { SystemRoles } from "models/ApiEnums";
import { KnowledgeTestTopicItemDto } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import Session from "services/Session";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    mouseOver: boolean;
    menuAnchorEl: any;
    dialog: any;
}

export interface IProps {
    item: KnowledgeTestTopicItemDto;
    onEdit: () => void;
    onNewTest: () => void;
    onRequiredMembers: () => void;
    onViewMembers: () => void;
    onDashboard: () => void;
}

type Props = IProps & WithTranslation & WithSnackbar & WithStyles<typeof FeedStyleClasses>;

/////////////////////////////////////////////////////////////////////////////////////

class KnowledgeTestTopicCard extends React.Component<Props, IState> {

    constructor(props: Props) {
        super(props);

        this.state = {
            dialog: null,
            mouseOver: false,
            menuAnchorEl: null
        };
    }

    ///
    private res(r: string, f: any = null) {
        return this.props.t("Views.KnowledgeTest.Components.KnowledgeTestTopicCard." + r, f);
    }

    ///
    private handleCloseMenu() {
        this.setState({ menuAnchorEl: null, mouseOver: false });
    }

    ///
    private handleEdit = () => {
        this.handleCloseMenu();
        this.props.onEdit();
    };

    ///
    private handleNewTest = () => {
        this.handleCloseMenu();
        this.props.onNewTest();
    };

    ///
    private handleRequiredMembers = () => {
        this.handleCloseMenu();
        this.props.onRequiredMembers();
    };

    ///
    private handleView = () => {
        this.handleCloseMenu();
        this.props.onViewMembers();
    };

    ///
    private buildOverflowMenu() {

        const actionMenu: Array<any> = [];

        actionMenu.push(<MenuItem key="view" onClick={this.handleNewTest}>{this.res("NewTestText")}</MenuItem>);
        actionMenu.push(<Divider key="divView" />);
        if (Session.hasRole(SystemRoles.TrainingManager)) actionMenu.push(<MenuItem key="view" onClick={this.handleRequiredMembers}>{this.res("EditRequiredUserText")}</MenuItem>);
        actionMenu.push(<MenuItem key="view" onClick={this.handleView}>{this.res("WhoCanAnswer")}</MenuItem>);

        return (
            <>
                <ButtonEllipsis onClick={(e) => { this.setState({ menuAnchorEl: e.currentTarget }); }} />
                <Menu
                    open={this.state.menuAnchorEl != null}
                    anchorEl={this.state.menuAnchorEl}
                    onClose={() => { this.handleCloseMenu(); }}
                >
                    {actionMenu}
                </Menu>
            </>
        );
    }

    ///
    public render() {
        const {
            classes,
            item
        } = this.props;

        const { mouseOver } = this.state;

        return (
            <>
                {this.state.dialog}

                <MuiPaper className={classes.card}
                    onMouseEnter={() => this.setState({ mouseOver: true })}
                    onMouseLeave={() => this.setState({ mouseOver: false })}
                >

                    <Grid container spacing={2} justifyContent="flex-start">

                        <Grid item>
                            <MuiImage size="sm" orientation="square" src={item.thumbnailUrl} />
                        </Grid>

                        <Grid item xs>

                            <MuiContainer margin="dense" >
                                <Grid container justifyContent="space-between" >
                                    <Grid item xs>
                                        <MuiClickable onClick={this.handleEdit} color={((item.numberOfKnowledgeTests) ? "textPrimary" : "muted")}>
                                            <Typography variant="h6">{item.name}</Typography>
                                        </MuiClickable>
                                    </Grid>
                                    <Grid item >
                                        <IconButtonEdit visible={mouseOver} onClick={this.handleEdit} size="small" />
                                    </Grid>
                                </Grid>
                            </MuiContainer>

                            <Grid container alignItems="center" justifyContent="space-between" className={this.props.classes.cardActions}>
                                <Grid item>
                                    <ButtonCardAction
                                        title={this.res("ButtonEditTitle")}
                                        onClick={this.handleEdit}
                                        startIcon={<IconClipboardCheck />}
                                    >
                                        <span>{item.numberOfKnowledgeTests}</span>
                                    </ButtonCardAction>
                                </Grid>
                                {
                                    Session.hasRole(SystemRoles.TrainingManager) &&
                                    <Grid item>
                                        <ButtonCardAction
                                            title={this.res("ButtonRequiredUsersTitle")}
                                            onClick={this.handleRequiredMembers}
                                            startIcon={<IconUsersPlus />}
                                            color={item.numberOfKnowledgeTests > 0 && item.numberOfRequiredMembers == 0 ? "warning" : "inherit"}
                                            link
                                        >
                                            <span>{item.numberOfKnowledgeTests > 0 && item.numberOfRequiredMembers == 0 ? this.props.t("Glossary.Nobody") : item.numberOfRequiredMembers}</span>
                                        </ButtonCardAction>
                                    </Grid>
                                }
                                <Grid item>
                                    <Grid container justifyContent="flex-end" alignItems="center">
                                        <Grid item>
                                            <ButtonDashboard onClick={this.props.onDashboard} />
                                        </Grid>
                                        <Grid item>
                                            {this.buildOverflowMenu()}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>


                </MuiPaper>
            </>
        );
    }
}

export default withSnackbar(withTranslation()(withStyles(FeedStyleClasses)(KnowledgeTestTopicCard)));